<script>
export default {
  name: 'IDEBaseMixin',
  methods: {
    // 确认提示
    __confirm (title, option = {}) {
      return this.$confirm(title, {
        customClass: 'ide-message-box',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        ...option
      })
    }
  }
}
</script>
